import { createGesture, useIonRouter } from '@ionic/react'
import { useEffect } from 'react'
import { useLocation } from 'react-router'

import { useAuth } from '@apps-common/contexts'
import { MY_MONITORING_SITE_HOME_VIEW, useMenuStore, useMyMonitoringSiteViewStore } from '@apps-common/stores'
import { ROUTE_SITES } from '@apps-my-monitoring/config/private-routes'

const EDGE_WIDTH = 28
const MIN_SWIPE_DISTANCE = 80
const MIN_SWIPE_VELOCITY = 0.2

const isInteractiveElement = (target: EventTarget | null) =>
  target instanceof HTMLElement &&
  !!target.closest('button, a, input, textarea, select, ion-button, ion-input, ion-textarea, ion-select, [role="button"]')

const hasActiveOverlay = () => !!document.querySelector('ion-modal.show-modal, ion-alert, ion-action-sheet, ion-popover')

export const SwipeNavigationGesture = () => {
  const router = useIonRouter()
  const location = useLocation()
  const { user } = useAuth()
  const { open, setOpen } = useMenuStore()
  const { viewKey, setViewKey } = useMyMonitoringSiteViewStore()

  useEffect(() => {
    if (!user || open) {
      return undefined
    }

    let shouldHandleSwipe = false

    const gesture = createGesture({
      el: document.body,
      gestureName: 'my-monitoring-swipe-navigation',
      threshold: 10,
      canStart: (detail) => {
        shouldHandleSwipe = detail.startX <= EDGE_WIDTH && !hasActiveOverlay() && !isInteractiveElement(detail.event?.target || null)

        return shouldHandleSwipe
      },
      onEnd: (detail) => {
        if (!shouldHandleSwipe || detail.deltaX < MIN_SWIPE_DISTANCE || detail.velocityX < MIN_SWIPE_VELOCITY) {
          return
        }

        if (location.pathname === ROUTE_SITES.path) {
          if (viewKey !== MY_MONITORING_SITE_HOME_VIEW) {
            setViewKey(MY_MONITORING_SITE_HOME_VIEW)

            return
          }

          setOpen(true)

          return
        }

        if (router.canGoBack()) {
          router.goBack()

          return
        }

        router.push(ROUTE_SITES.path, 'back', 'replace')
      }
    })

    gesture.enable(true)

    return () => {
      gesture.destroy()
    }
  }, [location.pathname, open, router, setOpen, setViewKey, user, viewKey])

  return null
}
